import type { Permission } from "@/api/client";

export type PermissionGroup = { group: string; permissions: Permission[] };

/** Groups by the key's prefix before the first dot, both sorted, so related permissions sit together. */
export function groupPermissions(permissions: Permission[]): PermissionGroup[] {
  const groups = new Map<string, Permission[]>();
  for (const permission of permissions) {
    const group = permission.key.split(".")[0] ?? permission.key;
    groups.set(group, [...(groups.get(group) ?? []), permission]);
  }
  return [...groups.entries()]
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([group, items]) => ({ group, permissions: [...items].sort((a, b) => a.key.localeCompare(b.key)) }));
}

export function holderCount(count: number) {
  return `${count} ${count === 1 ? "user" : "users"}`;
}
